import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Col, CardBody, CardHeader } from "reactstrap";
import { Accordion, Button } from "react-bootstrap";
import queryString from "query-string";

import PageWrapper from "../PageWrapper";
import FaqsTitle from "./FaqsTitle";

import CaretDown from "../../assets/img/caret-down-menu.svg";
import Map from "../../assets/img/maplocation.svg";
import Phone from "../../assets/img/phone-icon.svg";
import Mail from "../../assets/img/mail.svg";
import Whatsapp from "../../assets/img/whatsap-icon.svg";
import TurnosPDF from "../../assets/img/turnos_web.pdf";
import Check from "../../assets/img/check-circle-regular.svg";

const Content = ({ location }) => {
  const params = queryString.parse(location.search);
  const [opened, setOpen] = useState(params.ff === "true" ? true : false);
  const element = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (params.ff === "true") {
        document.documentElement.scrollTop =
          element.current.getBoundingClientRect().top + window.scrollY - 150;
        setOpen(true);
      }
    }, 300);
  }, [params.ff]);

  useEffect(() => {
    return () => setOpen(false);
  }, []);

  return (
    <PageWrapper>
      <Col xs="12">
        <FaqsTitle>Asistencia al Viajero</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Los planes disponen de cobertura de asistencia en viaje?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>
                  El plan A-10 Plus incluye asistencia a través de
                  <span className="semi-bold-font">Universal Assistance</span>{" "}
                  mientras que el plan C-60 Plus
                  otorga descuentos en distintos paquetes de asistencia al viajero. - Solicite su descuento{" "} 
                  <a
                    className="semi-bold-font links-inner-faqs"
                    href="https://altasalud.com.ar/universal-assistance"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    aquí
                  </a>
                  .
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                className="faqs__titles w-100"
              >
                ¿Es necesario activar el servicio o hacer algún llamado antes de
                viajar?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="1">
              <CardBody className="body-wrapper">
                <p>
                  Antes de viajar, te recomendamos comunicarte con la línea exclusiva de Universal Assistance para
                  afiliados de Alta Salud y descargar la aplicación móvil.
                  <br />
                  Consulte su cobertura: {" "}
                  <a
                    className="semi-bold-font links-inner-faqs"
                    href="https://altasalud.com.ar/universal-assistance"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    aquí
                  </a>
                  <br />
                  Universal Assistance al 0800-222-1939 / 0800-222-8565
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="2"
                className="faqs__titles w-100"
              >
                ¿Cómo accedo a los servicios de Universal Assistance?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="2">
              <CardBody className="body-wrapper">
                <p>
                  Se encuentra disponible en {" "}
                  <a
                    className="semi-bold-font links-inner-faqs"
                    href="https://play.google.com/store/apps/details?id=com.mobilenik.universalAssistance&hl=es_AR&gl=US"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Play Store
                  </a> y {" "}
                  <a
                    className="semi-bold-font links-inner-faqs"
                    href="https://apps.apple.com/ar/app/universal-assistance/id1005237356"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apple Store
                  </a> la APP de Universal Assistance con la que podrá
                  visualizar su cobertura médica, solicitar asistencia, chatear con un operador, acceder a telemedicina, y
                  otras herramientas.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="3"
                className="faqs__titles w-100"
              >
                Cómo usar la APP de Universal Assistance
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>

            <Accordion.Collapse eventKey="3">
              <CardBody className="body-wrapper">
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img src={Check} alt="check icon" className="icon-align pr-2" />
                    <span>
                      Descargá la APP de Universal Assistance
                    </span>
                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <img src={Check} alt="check icon" className="icon-align pr-2" />
                    <span>
                      Ingresá con el DNI del afiliado que desea utilizar el servicio.
                    </span>
                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <img src={Check} alt="check icon" className="icon-align pr-2" />
                    <span>
                      Si necesitás consultar la cobertura de otro integrante del grupo familiar, cerrá la sesión y accedé
                      nuevamente con el DNI correspondiente.
                    </span>
                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <img src={Check} alt="check icon" className="icon-align pr-2" />
                    <span>
                      Una vez ingresado, podrás visualizar la cobertura y los servicios disponibles para tu viaje.
                    </span>
                  </li>

                  {/* <li className="mb-2 d-flex align-items-center">
                    <img src={Check} alt="check icon" className="icon-align pr-2" />
                    <span>
                      Ir a mi cobertura
                    </span>
                  </li> */}

                </ul>

                {/* <p>
                  Este proceso debe realizarse para cada uno de los asociados que 
                  deseen obtener esta constancia, por lo que deberá cerrar la sesión e 
                  iniciarla con el otro D.N.I. solicitante.
                </p>

                <p>
                  Tenga en cuenta que estos procedimientos son obligatorios para que 
                  pueda acceder a la cobertura médica en tránsito. 
                  No se admiten reintegros por prestaciones y/o gastos médicos sanatoriales 
                  en ningún caso en que no se cumpla con el procedimiento previo 
                  de comunicación a Universal Assistance y/o no se sigan las directivas que ellos indican.
                </p> */}
                
              </CardBody>
            </Accordion.Collapse>
            
          </div>

        </Accordion>

        <FaqsTitle>Asociarme</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Cómo me asocio?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>Sumarte a Alta Salud es muy sencillo y con afiliación inmediata. Podés comunicarte con nuestro equipo
                  comercial por cualquiera de los siguientes canales para recibir asesoramiento personalizado</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Whatsapp}
                      alt="Phone icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Whatsapp: 11-6165-3681
                    </span>
                  </li>
                  {/* <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Phone}
                      alt="Phone icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Llamando al <a href="tel:08003332582">0800-333-2582.</a>
                    </span>
                  </li> */}
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="mail icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Email:{" "}
                      <a
                        className="links-inner-faqs"
                        href="mailto: comercial@altasalud.com.ar"
                      >
                        comercial@altasalud.com.ar
                      </a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img src={Map} alt="Map icon" className="icon-align pr-2" />{" "}
                    <span>Sede Central: Av. Nazca 1169</span>
                  </li>
                  
                </ul>

              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        <FaqsTitle>Autorizaciones</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Cómo autorizo una orden médica?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>
                  Puede solicitar su autorización a través del correo {" "}
                  <a
                        className="links-inner-faqs"
                        href="mailto: autorizacionesgaona@altasalud.com.ar"
                      >
                        autorizacionesgaona@altasalud.com.ar
                      </a>
                  {" "}enviando una
                  foto de la orden médica, la credencial del afiliado e indicando la institución donde se realizará la práctica.
                </p>
                {/* <ul className="list-unstyled">
                  
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="mail icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Vía mail a{" "}
                      <a
                        className="links-inner-faqs"
                        href="mailto: autorizacionesgaona@altasalud.com.ar"
                      >
                        autorizacionesgaona@altasalud.com.ar
                      </a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>Nuestro sitio web ingresando a su perfil.</span>
                  </li>
                </ul> */}
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                className="faqs__titles w-100"
              >
                ¿Cómo es el acceso a la atención?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="1">
              <CardBody className="body-wrapper">
                <p>
                  Para recibir atención con los prestadores de cartilla se debe presentar la credencial, el DNI y el
                  último comprobante de pago vigente.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          {/* <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="2"
                className="faqs__titles w-100"
              >
                ¿Cómo afilio a un recién nacido?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="2">
              <CardBody className="body-wrapper">
                <p>
                  Para afiliar a su bebé a Alta Salud debe presentar la
                  siguiente documentación:
                </p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>Epicrisis del alta del sanatorio donde nació.</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>Partida de nacimiento.</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>DNI.</span>
                  </li>
                </ul>

                <p>
                  Esta documentación original, deberá ser presentada
                  personalmente en Av. Gaona 3519/27.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div> */}
        </Accordion>

        <FaqsTitle>Centros Médicos Propios</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Cuáles son los centros medicos propios?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                {/* <ul>
                  <li><strong>Clínica Alta Salud</strong> ubicada en Av. Nazca 1169, el teléfono
                      es 4588-5800.
                  </li>
                  <li><b>Centro Médico Alta Salud</b> en Av. Gaona 3519/27, el teléfono
                      es <a href="tel:45885900">4588-5900</a>.</li>
                </ul> */}
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />
                    <span className="fw-bold">
                      <b style={{'fontWeight':'bold'}}>Clínica Alta Salud</b>{" "} ubicada en Av. Nazca 1169, el teléfono
                      es <a href="tel:45885800">4588-5800</a>.
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />
                    <span>
                        <b style={{'fontWeight':'bold'}}>Centro Médico Alta Salud</b>{" "} en Av. Gaona 3519/27, el teléfono
                        es <a href="tel:45885900">4588-5900</a>.
                    </span>
                  </li>
                </ul>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                className="faqs__titles w-100"
              >
                ¿Cómo sacar turnos online en el Centro Médico Alta Salud?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="1">
              <CardBody className="body-wrapper">
                <p>Puede solicitar un turno a través de cualquiera de los siguientes canales:</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Phone}
                      alt="phone icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Whatsapp:{" "}
                      <a href="tel:45885900">11 3864-1400 (atención las 24 hs).</a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Sitio web{" "}
                      <a
                        href="https://www.altasalud.com.ar/login"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="links-inner-faqs"
                      >
                        www.altasalud.com.ar/login
                      </a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Phone}
                      alt="phone icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Teléfono:{" "}
                      <a href="tel:45885900">4588-5900.</a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="Mail icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Correo electrónico:{" "}
                      <a
                        className="links-inner-faqs"
                        href="mailto: turnos@altasalud.com.ar"
                      >
                        turnos@altasalud.com.ar
                      </a>
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="Mail icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      App de Alta Salud: disponible para Android
                    </span>
                  </li>
                </ul>

                {/* <p>
                  Acceda a nuestro instructivo para aprender a navegatar
                  nuestros sistema de turnos online para nuestro Centro Médico
                  Alta Salud en Av Gaona 3519/27.
                  <br />
                  <br />
                  <a
                    className="links-inner-faqs"
                    href={TurnosPDF}
                    download="Turnos Web"
                  >
                    Descargar instructivo
                  </a>
                </p> */}
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        <FaqsTitle>Datos Generales</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Dónde se encuentra casa central?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p className="pt-3 d-flex align-items-center">
                  <img
                    src={Map}
                    alt="location icon"
                    className="pr-2 icon-align"
                  />
                  <span>La sede central de Clínica Alta Salud se encuentra en Av. Nazca 1169, CABA</span>
                </p>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.3888535521137!2d-58.476740985386!3d-34.619612465844966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc9edf9ade16d%3A0x3c311febf62899b3!2sAv.+Nazca+1169%2C+C1416ASA+CABA!5e0!3m2!1ses!2sar!4v1565892350803!5m2!1ses!2sar"
                  width="100%"
                  frameBorder="0"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  title="mapa"
                />
                <p className="pt-3 d-flex align-items-center">
                  <img
                    src={Phone}
                    alt="phone icon"
                    className="pr-2 icon-align"
                  />
                  <a href="tel:45885900">4588-5900</a>
                </p>
                <p className="pt-2 d-flex align-items-center">
                  <img src={Mail} alt="mail icon" className="pr-2 icon-align" />
                  <a
                    href="mailto:info@altasalud.com.ar"
                    className="links-inner-faqs"
                  >
                    info@altasalud.com.ar
                  </a>
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                className="faqs__titles w-100"
              >
                ¿Cuál es nuestro horario de atención?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="1">
              <CardBody className="body-wrapper">
                <p>
                  La atención presencial y telefónica se brinda de lunes a viernes de 8:00 a 18:00 horas.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="2"
                className="faqs__titles w-100"
              >
                ¿Qué hacer ante una urgencia o emergencia?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="2">
              <CardBody className="body-wrapper">
                <p>
                  En caso de requerir asistencia médica domiciliaria, comuníquese al 0810-999-2628 para solicitar el
                  servicio de ambulancia.
                </p><br />
                <p>
                  También puede concurrir directamente a la guardia de cualquiera de las instituciones incluidas en la
                  cartilla de prestadores.
                </p>
            
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="3"
                className="faqs__titles w-100"
              >
                ¿Hasta dónde es el área de cobertura?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="3">
              <CardBody className="body-wrapper">
                <p>
                  La cobertura comprende la Ciudad Autónoma de Buenos Aires y el primer y segundo cordón del Gran Buenos Aires.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        <div ref={element}>
          <FaqsTitle>Facturación</FaqsTitle>
          <Accordion
            id="facturacion"
            defaultActiveKey={`${opened ? "0" : false}`}
          >
            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="0"
                  className="faqs__titles w-100"
                >
                  ¿Como abono la factura?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="0">
                <CardBody className="body-wrapper">
                  {/* <p>
                    <span className="d-block faqs-inner-titles">
                      PAGO MIS CUENTAS
                    </span>
                    Desde su Home Banking, o ingresando a{" "}
                    <a
                      className="links-inner-faqs"
                      href="https://pagomiscuentas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.pagomiscuentas.com
                    </a>{" "}
                    por favor colocar en la parte de “identificación” el número
                    de afiliado para poder reconocer el pago realizado. Siempre
                    especifique que está pagando medicina prepaga.
                  </p>
                  <p>
                    <span className="d-block faqs-inner-titles">
                      DÉBITO DIRECTO EN CUENTA PREEXISTENTE
                    </span>
                    Si desea utilizar este servicio deberá acercarse por única
                    vez a Av. Gaona 3519/27 en el horario de 08 a 18 horas, con
                    el comprobante de CBU y DNI para completar el formulario de
                    autorización y elegir fecha de vencimiento.
                  </p>
                  <p>
                    <span className="d-block faqs-inner-titles">
                      DÉBITO DIRECTO CON APERTURA DE CUENTA EN BANCO GALICIA
                    </span>
                    Usted tiene la posibilidad de abrir una cuenta en Banco
                    Galicia Sucursal Flores Norte concurriendo a la misma
                    obteniendo importantes beneficios.
                  </p>
                  <p>
                    <span className="d-block faqs-inner-titles">
                      PAGO FÁCIL y/o RAPIPAGO
                    </span>
                    Con su factura en cualquier puesto de cobro.
                  </p>
                  <p>
                    <span className="d-block faqs-inner-titles">
                      DÉBITO AUTÓMATICO DE TARJETA VISA / MASTERCARD
                    </span>
                    Si desea utilizar este servicio deberá acercarse por única
                    vez a Av. Gaona 3519/27, con su tarjeta y DNI para completar
                    el formulario de autorización o por mail a{" "}
                    <a
                      className="links-inner-faqs"
                      href="mailto: facturacion@altasalud.com.ar"
                    >
                      facturacion@altasalud.com.ar
                    </a>
                  </p>
                  <p>
                    <span className="d-block faqs-inner-titles">
                      DEPÓSITOS O TRANSFERENCIA BANCARIA A LA CUENTA DE LA
                      EMPRESA
                    </span>
                    Banco Galicia. Solicitar datos al personal administrativo
                    llamando al 4588-5900 o vía mail a{" "}
                    <a
                      className="links-inner-faqs"
                      href="mailto: gestion@altasalud.com.ar"
                    >
                      gestion@altasalud.com.ar
                    </a>
                  </p> */}
                  <p>Puede abonar su cuota a través de los siguientes medios de pago:</p><br/>
              
                  <ul>
                    <li>Pago Mis Cuentas</li>
                    <li>Débito automático en cuenta bancaria.</li>
                    <li>Débito automático con tarjeta de crédito.</li>
                    <li>Transferencia bancaria.</li>
                    <li>Depósito en cuenta bancaria.</li>
                  </ul>
                </CardBody>
              </Accordion.Collapse>
            </div>

            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="1"
                  className="faqs__titles w-100"
                >
                  ¿Qué sucede si abono la factura fuera de término?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="1">
                <CardBody className="body-wrapper">
                  <p>
                    Si el pago se efectúa con posterioridad a la segunda fecha de vencimiento, será considerado fuera de
                    término y podrá generar recargos.
                  </p>
                  <p>Ante cualquier consulta, puede comunicarse con nuestros canales de atención para recibir asesoramiento.</p>
                </CardBody>
              </Accordion.Collapse>
            </div>

            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="2"
                  className="faqs__titles w-100"
                >
                  ¿Cómo hago para solicitar la factura?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="2">
                <CardBody className="body-wrapper">
                  <ul className="list-unstyled">
                    <li className="d-flex">
                      <img
                        src={Mail}
                        alt="mail icon"
                        className="pr-2 icon-align"
                      />
                      <span>Vía mail a</span>{" "}
                      <a
                        href="mailto: facturacion@altasalud.com.ar."
                        className="links-inner-faqs ml-1"
                      >
                        facturacion@altasalud.com.ar.
                      </a>
                    </li>
                    <li className="d-flex">
                      <img
                        src={Phone}
                        alt="phone icon"
                        className="pr-2 icon-align"
                      />
                      <span>
                        Por WhatsApp al 11 5924-4301
                      </span>
                    </li>
                  </ul>

                  <p>
                    La factura enviada por email tiene la misma validez que la
                    factura impresa y se puede abonar con los mismos medios de
                    pago descriptos anteriormente.
                  </p>
                </CardBody>
              </Accordion.Collapse>
            </div>

            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="3"
                  className="faqs__titles w-100"
                >
                  ¿Se puede abonar con facturas anteriores?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="3">
                <CardBody className="body-wrapper">
                  <p>
                    La factura es válida únicamente para el período que indica. Para abonar el mes en curso, debe utilizar la
                    factura correspondiente a ese período.
                  </p>
                </CardBody>
              </Accordion.Collapse>
            </div>

            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="4"
                  className="faqs__titles w-100"
                >
                  ¿Cómo doy de baja el debito automático?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="4">
                <CardBody className="body-wrapper">
                  <p>
                    Para solicitar la baja del débito automático usted puede
                    contactarse vía
                    mail a{" "}
                    <a
                      href="mailto: facturacion@altasalud.com.ar"
                      className="links-inner-faqs"
                    >
                      facturacion@altasalud.com.ar
                    </a>{" "}
                    
                  </p>
                </CardBody>
              </Accordion.Collapse>
            </div>

            <div>
              <CardHeader className="faqs__card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="5"
                  className="faqs__titles w-100"
                >
                  ¿Cómo puedo saber si tengo cuotas pendientes?
                  <img src={CaretDown} alt="caret down" className="pl-2" />
                </Accordion.Toggle>
              </CardHeader>
              <Accordion.Collapse eventKey="5">
                <CardBody className="body-wrapper">
                  <p>
                    En su factura mensual podrá verificar si existe algún saldo pendiente y el importe correspondiente. Para
                    evitar diferencias o saldos adeudados, se recomienda efectuar el pago antes de la primera fecha de
                    vencimiento.
                  </p>
                </CardBody>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>

        <FaqsTitle>Odontología</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Con quién me debo contactar para acceder a los servicios de
                odontología?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>
                  Para consultas sobre cobertura odontológica y prestadores, puede comunicarse con Dental Center:
                </p>
                <ul>
                  <li>Dirección: Viamonte 867, Piso 2°, Depto. 207, CABA.</li>
                  <li>Teléfonos: 4328-5625 / 4328-2629 / 4328-0041 (Interno 103).</li>
                  <li>Turnos: 4328-5625 de lunes a viernes de 10 a 18 hs.</li>
                  <li>WhatsApp: 11 2261-7500, disponible las 24 hs.</li>
                  <li>Correo electrónico: info@dentalcenter.com.ar.</li>
                  <li>Portal de pacientes y cartilla odontológica: <a style={{'color': '#007bff','textDecoration':'underline'}} href="https://www.dentalcenter.com.ar" target="_blank" rel="noopener noreferrer">www.dentalcenter.com.ar</a></li>
                </ul><br />
                <p>Ingrese al portal con su DNI.</p>
                
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        <FaqsTitle>Quiero ser un prestador</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Cómo puedo formar parte de la cartilla de prestadores o del
                cuerpo profesional de los centros propios?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>
                  Quienes deseen incorporarse a nuestro equipo de trabajo, ya sea en nuestros centros propios o como
                  parte de la cartilla de prestadores, pueden enviar su CV o carta de presentación por correo electrónico a{" "}
                  <a
                    className="links-inner-faqs ml-1"
                    href="mailto: info@altasalud.com.ar"
                  >
                    info@altasalud.com.ar
                  </a>
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        <FaqsTitle>Red de Prestadores</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                ¿Cómo accedo a la cartilla medica?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>
                  Conozca todos los prestadores de nuestra cartilla médica ingresando a: {" "}
                  <a
                    className="links-inner-faqs"
                    href="https://www.altasalud.com.ar/cartilla-medica" target="_blank" rel="noopener noreferrer"
                  >
                    www.altasalud.com.ar/cartilla-medica
                  </a>
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>

        

        <FaqsTitle>Tramites Generales</FaqsTitle>
        <Accordion>
          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="faqs__titles w-100"
              >
                Pérdida, robo o deterioro de la credencial.
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="0">
              <CardBody className="body-wrapper">
                <p>Puede obtener su credencial digital de forma simple y rápida ingresando a la App de Alta Salud.
                  Si desea una credencial física, puede solicitarla a través de cualquiera de los siguientes canales:
                </p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>A través de nuestro portal web.</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img src={Map} alt="Map icon" className="icon-align pr-2" />{" "}
                    <span>
                      Presentándose en Av. Nazca 1169, CABA, con su DNI para acreditar identidad.
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="Mail icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>
                      Vía correo electrónico a{" "}
                      <a
                        className="links-inner-faqs"
                        href="mailto: afiliaciones@altasalud.com.ar"
                      >
                        afiliaciones@altasalud.com.ar
                      </a>
                    </span>
                  </li>
                </ul>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                className="faqs__titles w-100"
              >
                ¿Cómo solicito la baja del servicio?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="1">
              <CardBody className="body-wrapper">
                <p>
                  La solicitud de baja deberá ser realizada por el titular o adherente a través de alguno de los siguientes canales:
                </p>
                <ul>
                  <li>Clínica Alta Salud, Sector Afiliaciones: Av. Nazca 1169, CABA.</li>
                  <li>Correo electrónico: afiliaciones@altasalud.com.ar.</li>
                </ul>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="2"
                className="faqs__titles w-100"
              >
                ¿Cómo puedo cambiar mi plan?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="2">
              <CardBody className="body-wrapper">
                <p>
                  Para conocer las alternativas disponibles, beneficios y valores de cada plan, puede comunicarse con el {" "}
                  <b style={{'fontWeight':'bold'}}>sector afiliaciones</b> a través del correo electrónico afiliaciones@altasalud.com.ar.
                </p>
              </CardBody>
            </Accordion.Collapse>
          </div>

          <div>
            <CardHeader className="faqs__card-header">
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="3"
                className="faqs__titles w-100"
              >
                ¿Cómo hago un cambio de domicilio?
                <img src={CaretDown} alt="caret down" className="pl-2" />
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey="3">
              <CardBody className="body-wrapper">
                <p>
                  El cambio de domicilio deberá ser realizado por el titular o adherente enviando la solicitud por correo electrónico a afiliaciones@altasalud.com.ar.
                </p>
                {/* <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Check}
                      alt="check icon"
                      className="icon-align pr-2"
                    />{" "}
                    <span>A través de nuestro portal web.</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img src={Map} alt="Map icon" className="icon-align pr-2" />{" "}
                    <span>Presencialmente en Av. Gaona 3519/27.</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <img
                      src={Mail}
                      alt="Mail icon"
                      className="icon-align pr-2"
                    />
                    <span>Por mail a</span>
                    <a
                      className="links-inner-faqs ml-1"
                      href="mailto: afiliaciones@altasalud.com.ar"
                    >
                      afiliaciones@altasalud.com.ar
                    </a>
                  </li>
                </ul> */}
              </CardBody>
            </Accordion.Collapse>
          </div>
        </Accordion>
      </Col>
    </PageWrapper>
  );
};

export default withRouter(Content);
